import {styled} from '@linaria/react';
import React from 'react';
import {Video} from '../Video/Video';
import {VideoType} from '../Video/type';
import {useVideoOrFallbackImage} from './utils/useVideoOrFallbackImage';

interface VideoOrFallbackImageProps
  extends React.VideoHTMLAttributes<HTMLVideoElement> {
  ['data-testid']?: string;
  className?: string;
  style?: React.CSSProperties;
  video?: VideoType;
  image: React.ReactNode;
}

export const VideoOrFallbackImage: React.FC<VideoOrFallbackImageProps> = ({
  'data-testid': dataTestId,
  className,
  style,
  video,
  image,
  ...rest
}) => {
  const {containerRef, handleCanPlay, videoRef} =
    useVideoOrFallbackImage(video);

  return (
    <Wrapper
      data-testid={dataTestId}
      className={className}
      style={style}
      ref={containerRef}
    >
      {video ? (
        <Video
          {...rest}
          disablePictureInPicture
          disableRemotePlayback
          playsInline
          muted
          loop
          controls={false}
          sources={video.sources}
          aria-label={video.description}
          preload="auto"
          poster={video.fallbackImage.url}
          onCanPlay={handleCanPlay}
          ref={videoRef}
        />
      ) : (
        image
      )}
    </Wrapper>
  );
};

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  > video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    /* Hardware acceleration for smoother playback on iOS */
    transform: translateZ(0);
    backface-visibility: hidden;
  }
`;
